import { render } from "./location-section.vue?vue&type=template&id=70ae8c46"
import script from "./location-section.vue?vue&type=script&lang=js"
export * from "./location-section.vue?vue&type=script&lang=js"

import "./location-section.vue?vue&type=style&index=0&id=70ae8c46&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__